'use client';

import { useState, useEffect } from 'react';

const KEY = 'cookieConsent';

/**
 * Cookie consent banner. The site only uses technical cookies (login session,
 * security, preferences) — no advertising/tracking. Choice is stored locally;
 * "Tolak" simply dismisses since there is nothing optional to disable.
 */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch { /* storage unavailable — stay hidden */ }
  }, []);

  const choose = (choice) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ choice, at: Date.now() }));
    } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="m-rise fixed inset-x-4 bottom-4 z-[60] sm:inset-x-auto sm:bottom-6 sm:right-6 sm:max-w-sm">
      <div className="rounded-2xl bg-slate-900/95 p-4 text-white shadow-2xl ring-1 ring-white/10 backdrop-blur">
        <p className="text-sm font-bold">Kami memakai cookie 🍪</p>
        <p className="mt-1 text-xs leading-relaxed text-white/70">
          Cookie teknis agar login & pemesanan berfungsi. Tanpa cookie iklan/pelacakan.{' '}
          <a href="/cookie-policy/" className="font-semibold text-emerald-300 hover:underline">
            Kebijakan Cookie
          </a>
        </p>
        <div className="mt-3 flex gap-2">
          <button
            onClick={() => choose('rejected')}
            className="flex-1 rounded-xl border border-white/20 px-3 py-2 text-xs font-semibold text-white/80 transition-colors hover:bg-white/10"
          >
            Tolak
          </button>
          <button
            onClick={() => choose('accepted')}
            className="flex-1 rounded-xl bg-emerald-500 px-3 py-2 text-xs font-bold text-white transition-all hover:bg-emerald-400 active:scale-[0.98]"
          >
            Terima
          </button>
        </div>
      </div>
    </div>
  );
}
